import { PeerStats } from '../../preciate-stream/types';

export const INITIAL_PEER_STATS: PeerStats = {
  timestamp: Date.now(),
  packetsReceived: 0,
  bytesReceived: 0,
  framesReceived: 0,
  packetsSent: 0,
  bytesSent: 0,
  framesSent: 0,
  outboundQLR: '',
  packetsLost: 0,
  videoPacketsLost: 0,
  audioPacketsLost: 0,
  audioJitter: 0,
  audioJitterBufferDelay: 0,
  videoJitter: 0,
  videoJitterBufferDelay: 0,
  limitationDuration: 0,
  frameHeight: 0,
  frameWidth: 0,
  framesPerSecond: 0,
  framesDropped: 0,
  mediaSourceId: '',
  nackCount: 0,
  firCount: 0,
  pliCount: 0,
  framesEncoded: 0,
  keyFramesEncoded: 0,
  targetBitrate: 0,
};
